import React, { useState } from "react";
import { IonAlert, IonButton, IonIcon } from "@ionic/react";
import { logOutOutline } from "ionicons/icons";
import "./LogOut.css";
import { useHistory } from "react-router";

const LogOut: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const history = useHistory();

  return (
    <React.Fragment>
      <IonButton size="default" onClick={() => setIsOpen(!isOpen)} color="danger" >
        <IonIcon color="dark" slot="start" icon={logOutOutline} />
        Sair
      </IonButton>
      <IonAlert
        header="Deseja Sair ?"
        buttons={[
          {
            text: "Voltar",
            role: "cancel",
            cssClass: "alert-button-cancel",
            handler: () => {
              setIsOpen(!isOpen);
            },
          },
          {
            text: "Sair",
            role: "confirm",
            cssClass: "alert-button-confirm",
            handler: () => {
              localStorage.removeItem("user");
              window.location.href = "/login";
            },
          },
        ]}
        isOpen={isOpen}
      ></IonAlert>
    </React.Fragment>
  );
};

export default LogOut;
